module.exports = __webpack_public_path__ + "img/36.bfd33305.jpg";